import { useGameSessionHistory } from '../api/useGameSessionHistory'
import { GameSessionList } from './GameSessionList'

/** The matches one kill streak happened in, so a reviewer can open them.
 *
 *  The killer's own sessions where they killed this victim, overlapping the
 *  streak's first and last kill -- the same session rows the account's Play
 *  tab shows, with the kill feed and who killed them, rather than a summary
 *  that has to be taken on trust.
 */
export const StreakSessions = ({
    killerId,
    victimId,
    began,
    ended,
}: {
    killerId: number
    victimId: number
    began: string
    ended: string
}) => {
    const { sessions, count, isLoading, fetchNextPage, hasNextPage } = useGameSessionHistory({
        user_id: killerId,
        opponentId: victimId,
        betweenFrom: began,
        betweenTo: ended,
    })

    if (isLoading) return <div className='py-1 text-white/40'>loading the matches...</div>
    if (!sessions?.length) return <div className='py-1 text-white/40'>No closed match found for this streak.</div>

    return (
        <div className='flex max-w-full flex-col gap-1 overflow-x-auto py-1'>
            <span className='text-white/40'>
                {count} match{count === 1 ? '' : 'es'}
            </span>
            <GameSessionList sessions={sessions} />
            {hasNextPage && (
                <button
                    type='button'
                    onClick={() => fetchNextPage()}
                    className='self-start underline opacity-60 hover:opacity-100'
                >
                    more
                </button>
            )}
        </div>
    )
}
